import $ from 'jquery';

// ── Icons ────────────────────────────────────────────────────────────────────

const svgUpload = `<svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none">
  <path d="M24.3963 24.3961L18.2973 18.2971L12.1982 24.3961" stroke="black" stroke-opacity="0.4" stroke-width="1.52475" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M18.2969 18.2971V32.0198" stroke="black" stroke-opacity="0.4" stroke-width="1.52475" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M31.0897 28.0402C32.5768 27.2294 33.7516 25.9465 34.4287 24.3939C35.1057 22.8414 35.2465 21.1075 34.8287 19.466C34.4109 17.8246 33.4584 16.369 32.1214 15.329C30.7845 14.289 29.1393 13.7239 27.4455 13.7228H25.5243C25.0628 11.9377 24.2026 10.2804 23.0084 8.87557C21.8142 7.47075 20.3171 6.35494 18.6296 5.61201C16.942 4.86909 15.1081 4.51839 13.2655 4.58627C11.4229 4.65416 9.61974 5.13887 7.99147 6.00396C6.36321 6.86906 4.95224 8.09202 3.86465 9.58091C2.77706 11.0698 2.04115 12.7859 1.71224 14.6001C1.38334 16.4143 1.47 18.2795 1.96571 20.0555C2.46142 21.8314 3.35328 23.4718 4.57424 24.8535" stroke="black" stroke-opacity="0.4" stroke-width="1.52475" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

const svgCheck = `<svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none">
  <circle cx="18.5" cy="18.5" r="14" fill="#22c55e" opacity="0.15"/>
  <path d="M11 19l5 5 10-10" stroke="#22c55e" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

// ── Allowed file types (enforced everywhere) ─────────────────────────────────

const ALLOWED_TYPES = [
	{ ext: '.pdf', mime: 'application/pdf' },
	{
		ext: '.docx',
		mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	},
	{ ext: '.mp4', mime: 'video/mp4' },
];

/** Returns true if the File matches any entry in ALLOWED_TYPES. */
function isAllowedFile(file) {
	const ext = '.' + file.name.split('.').pop().toLowerCase();
	const mime = (file.type || '').toLowerCase();
	return ALLOWED_TYPES.some((t) => ext === t.ext || mime === t.mime);
}

/** Comma-separated accept string built from ALLOWED_TYPES (for <input accept>). */
const ALLOWED_ACCEPT = ALLOWED_TYPES.map((t) => `${t.ext},${t.mime}`).join(',');

/** Human-readable label, e.g. "PDF, DOCX" */
const ALLOWED_LABEL = ALLOWED_TYPES.map((t) =>
	t.ext.replace('.', '').toUpperCase(),
).join(', ');

document.addEventListener(
	'change',
	function (e) {
		if (e.target.type !== 'file') return;

		const $input = $(e.target);
		const $wrapper = $input.closest('.gfield.upload--dnd');
		if (!$wrapper.length) return;

		const $zone = $wrapper.find('.custom-dnd-zone');
		if (!$zone.length) return;

		if (e.target.files && e.target.files.length > 0) {
			const file = e.target.files[0];

			if (!isAllowedFile(file)) {
				// Clear the input so GF never sees the invalid file
				e.target.value = '';
				showError($zone, `Only ${ALLOWED_LABEL} files are allowed.`);
				console.warn('[uploadDnD] Rejected file (change):', file.name);
				return;
			}

			setSelected($zone, file.name);
		} else {
			setEmpty($zone, $wrapper);
		}
	},
	true,
); // ← capture phase

// ── State helpers ─────────────────────────────────────────────────────────────

function setSelected($zone, name) {
	$zone.addClass('has-file');
	$zone.find('.dnd-icon').html(svgCheck);
	$zone.find('.dnd-title').text(name);
	$zone
		.find('.dnd-desc')
		.html(
			'<span class="dnd-file-ready">&#10003; File ready to submit</span>',
		);
	$zone.find('.dnd-btn').text('Change file');
	$zone.data('hasFile', true);
}

function setEmpty($zone, $wrapper) {
	const subText = $zone.data('subText') || '';
	const defaultTitle =
		$zone.data('defaultTitle') || '<u><b>Select a file here</b></u>';
	$zone.removeClass('has-file');
	$zone.find('.dnd-icon').html(svgUpload);
	$zone.find('.dnd-title').html(defaultTitle);
	$zone.find('.dnd-desc').text(subText);
	$zone.find('.dnd-btn').text('Select file');
	$zone.data('hasFile', false);
}

/**
 * Temporarily show an error message in the drop zone's description area.
 */
function showError($zone, message) {
	const $desc = $zone.find('.dnd-desc');
	const original = $desc.html();
	$desc.html(
		`<span style="color:#e53e3e;font-weight:600;">${message}</span>`,
	);
	setTimeout(() => $desc.html(original), 3500);
}

// ── Inject custom UI ──────────────────────────────────────────────────────────

const uploadDnD = () => {
	const $dndWrappers = $('.gfield.upload--dnd');
	if ($dndWrappers.length === 0) return;

	$dndWrappers.each(function () {
		const $wrapper = $(this);
		const $inputContainer = $wrapper.find('.ginput_container_fileupload');
		const $input = $inputContainer.find('input[type="file"]');
		const $description = $wrapper.find('.gfield_description').first();

		// Skip if already injected
		if ($inputContainer.find('.custom-dnd-zone').length > 0) return;

		const inputId =
			$input.attr('id') ||
			'dnd-input-' + Math.random().toString(36).slice(2);
		if (!$input.attr('id')) $input.attr('id', inputId);

		const defaultTitle = 'Select a file <u><b>here</b></u>';
		let subText = `Accepted file types: ${ALLOWED_LABEL}. Max. file size: 100 MB.`;
		if ($description.length && $description.text().trim() !== '') {
			subText = $description.text().trim();
			$description.hide();
		}

		// Override input's accept so the native file picker also restricts types
		$input.attr('accept', ALLOWED_ACCEPT);

		const $zone = $(`
            <label for="${inputId}" class="custom-dnd-zone">
                <div class="dnd-icon">${svgUpload}</div>
                <div class="dnd-content">
                    <div class="dnd-title">${defaultTitle}</div>
                    <div class="dnd-desc">${subText}</div>
                </div>
                <span class="dnd-btn">Select file</span>
            </label>
        `);

		// Store defaults on the element so setEmpty() can read them
		$zone.data('defaultTitle', defaultTitle);
		$zone.data('subText', subText);
		$zone.data('hasFile', false);

		$inputContainer.append($zone);

		// ── Drag & drop at document level ─────────────────────────────────────
		// We use elementFromPoint() instead of e.target because Elementor popup
		// overlays intercept e.target, making it never equal our zone element.
		const zoneEl = $zone[0];
		const inputEl = $input[0];

		function isOverZone(e) {
			const el = document.elementFromPoint(e.clientX, e.clientY);
			return el && (el === zoneEl || zoneEl.contains(el));
		}

		document.addEventListener('dragover', function (e) {
			if (isOverZone(e)) {
				e.preventDefault();
				e.dataTransfer.dropEffect = 'copy';
				if (!$zone.hasClass('is-dragover')) {
					$zone.addClass('is-dragover');
				}
			} else {
				$zone.removeClass('is-dragover');
			}
		});

		document.addEventListener('dragleave', function (e) {
			if (!isOverZone(e)) {
				$zone.removeClass('is-dragover');
			}
		});

		document.addEventListener('drop', function (e) {
			if (isOverZone(e)) {
				e.preventDefault();
				$zone.removeClass('is-dragover');

				const dt = e.dataTransfer;
				if (dt && dt.files && dt.files.length) {
					const file = dt.files[0];

					// Validate against allowed types
					if (!isAllowedFile(file)) {
						showError(
							$zone,
							`Only ${ALLOWED_LABEL} files are allowed.`,
						);
						console.warn(
							'[uploadDnD] Rejected file (drop):',
							file.name,
						);
						return;
					}

					try {
						const newDt = new DataTransfer();
						newDt.items.add(file);
						inputEl.files = newDt.files;
						inputEl.dispatchEvent(
							new Event('change', { bubbles: true }),
						);
					} catch (err) {
						console.error('Drop assignment error:', err);
					}
				}
			}
		});

		// ── MutationObserver: sync with GF's own file preview elements ────────
		// GF renders a preview row above our zone when a file is selected.
		// We read the filename from that row to update our UI.
		// When GF removes the row (user deleted), we reset our UI.
		let syncTimer = null;

		function syncWithGf() {
			// GF single-file preview: <strong class="gfield_fileupload_filename">name</strong>
			const $gfName = $wrapper
				.find('.gfield_fileupload_filename')
				.first();
			if ($gfName.length) {
				const name = $gfName.text().trim();
				if (name) {
					setSelected($zone, name);
					return;
				}
			}

			// GF multifile progress row
			const $gfRow = $wrapper
				.find('.ginput_preview, .gfield_fileupload_progress')
				.first();
			if ($gfRow.length) {
				const name =
					$gfRow.find('.gfield_fileupload_filename').text().trim() ||
					$gfRow.text().replace(/\s+/g, ' ').trim();
				if (name) {
					setSelected($zone, name);
					return;
				}
			}

			// Nothing from GF — check native input as fallback
			const input = $inputContainer.find('input[type="file"]')[0];
			if (input && input.files && input.files.length > 0) {
				setSelected($zone, input.files[0].name);
				return;
			}

			// File was deleted — reset UI
			if ($zone.data('hasFile')) {
				setEmpty($zone, $wrapper);
			}
		}

		const fieldObserver = new MutationObserver(() => {
			clearTimeout(syncTimer);
			syncTimer = setTimeout(syncWithGf, 300);
		});

		fieldObserver.observe($wrapper[0], { childList: true, subtree: true });
	});
};

// ── Init triggers ─────────────────────────────────────────────────────────────

try {
	$(document).ready(() => uploadDnD());

	// GravityForms re-render (multi-page forms)
	$(document).on('gform_post_render', () => uploadDnD());

	// Elementor popup open events
	$(document).on('elementor/popup/show', () =>
		setTimeout(() => uploadDnD(), 150),
	);
	$(window).on('elementor-pro/popup/show', () =>
		setTimeout(() => uploadDnD(), 150),
	);

	// Body MutationObserver — catches any dynamic injection (popups, off-canvas, etc.)
	const bodyObserver = new MutationObserver((mutations) => {
		const hasAdded = mutations.some((m) => m.addedNodes.length > 0);
		if (!hasAdded) return;
		uploadDnD();
	});
	bodyObserver.observe(document.body, { childList: true, subtree: true });
} catch (error) {
	console.error('[uploadDnD]', error);
}
